import { render, staticRenderFns } from "./BookingDeleteConformationDialog.vue?vue&type=template&id=45e76010&scoped=true&"
import script from "./BookingDeleteConformationDialog.vue?vue&type=script&lang=js&"
export * from "./BookingDeleteConformationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e76010",
  null
  
)

export default component.exports